import React from 'react'
import SkeletonBlock from './SkeletonBlock'
import SkeletonText from './SkeletonText'
import SkeletonCard from './SkeletonCard'

/**
 * Rounds page placeholder: top button row + a stack of round-card skeletons.
 */
function RoundsSkeleton() {
  return (
    <div className="min-h-screen bg-app">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* Page button row - primary + secondary */}
        <div className="flex flex-row items-center sm:justify-end gap-3">
          <SkeletonBlock className="flex-1 sm:flex-none sm:w-36 h-11 rounded-lg" />
          <SkeletonBlock className="flex-1 sm:flex-none sm:w-36 h-11 rounded-lg" />
        </div>
        {/* Round cards */}
        <div className="grid grid-cols-1 gap-6">
          {[0, 1, 2].map((i) => (
            <SkeletonCard key={i} className="p-6">
              <div className="pb-5 mb-5 border-b border-border-subtle">
                <SkeletonText className="w-2/3 h-5 mb-2" />
                <SkeletonText className="w-1/2 h-4" />
              </div>
              <div className="space-y-3">
                <SkeletonText className="w-full h-4" />
                <SkeletonText className="w-3/4 h-4" />
              </div>
            </SkeletonCard>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RoundsSkeleton
